var DEFAULT_NAMESPACE = "platform.navigation";
var DEFAULT_RECORD_ID = "main-navigation";
var DEFAULT_ROUTES = {
  api: "/api/platform.navigation",
  page: "/dashboard/platform.navigation"
};

function normalizeText(value) {
  return (value || "").toString().trim();
}

function getCurrentPage(context) {
  return (((context || {}).dashboard || {}).currentPage) || ((context || {}).page) || {};
}

function getRoutes(context) {
  var currentPage = getCurrentPage(context);
  var routes = currentPage.routes || {};

  return {
    api: normalizeText(routes.api) || DEFAULT_ROUTES.api,
    page: normalizeText(routes.page) || DEFAULT_ROUTES.page
  };
}

function getWorkspaceContract(context, recordId) {
  var currentPage = getCurrentPage(context);
  var routes = getRoutes(context);
  var namespace = normalizeText(currentPage.namespace) || DEFAULT_NAMESPACE;
  var normalizedRecordId = normalizeText(recordId) || DEFAULT_RECORD_ID;
  var detailPage = routes.page.replace(/\/$/, "") + "/" + encodeURIComponent(normalizedRecordId);

  return {
    namespace: namespace,
    recordId: normalizedRecordId,
    routes: routes,
    workspace: {
      namespace: namespace,
      api: routes.api,
      page: detailPage,
      recordId: normalizedRecordId
    }
  };
}

module.exports = {
  DEFAULT_NAMESPACE: DEFAULT_NAMESPACE,
  DEFAULT_RECORD_ID: DEFAULT_RECORD_ID,
  DEFAULT_ROUTES: DEFAULT_ROUTES,
  getRoutes: getRoutes,
  getWorkspaceContract: getWorkspaceContract
};
